var gql = require("graphql-tag");

const TARIFFS_QUERY_FOR_SEO = gql`
    query Tariffs_For_Seo(
        $filter: String
        $limit: Int
        $offset: Int
        $sort: String
        $exists: String
        $shuffle: Boolean
        $providerJoin: Boolean
        $fillFieldInfo: Boolean
    ) {
        tariffs(
            filter: $filter
            limit: $limit
            offset: $offset
            sort: $sort
            exists: $exists
            shuffle: $shuffle
            providerJoin: $providerJoin
            fillFieldInfo: $fillFieldInfo
        ) {
            data {
                id
                name
                mobile_new {
                    calls
                    sms
                    calls_type
                    sms_type
                }
                internet {
                    speed_in
                }
                tv {
                    channels
                    channels_hd
                }
            }
            info {
                tariffNamesInternetSpeedMaxList
                tariffNamesInternetSpeedMinList
                tariffNamesInternetSpeedUnder100List
                tariffNamesInternetSpeedOver100List
                tariffNamesTvChannelsMaxList
                tariffNamesWithChannelList
                tariffNamesMobileCallsMaxList
                tariffNamesWithMobileCallsSmsList
                tariffNamesWithMobileCallsList
            }
        }
    }
`;

export default TARIFFS_QUERY_FOR_SEO;
